import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export const deleteUserById = async (userId: number): Promise<UserProfile> => {
  const { data } = await client.delete<UserProfile>(`/admin/users/${userId}`);

  return data;
};
